import { Component } from 'react'
import { injectIntl } from 'react-intl'
import withToast from 'src/components/Toast'
import intlMessages from './translations'

class OfflineStatus extends Component {
  componentDidUpdate() {
    const { intl, isOffline, toast } = this.props

    if (!isOffline.online) {
      toast({
        title: intl.formatMessage(intlMessages.offlineStatusMessage),
        description: intl.formatMessage(intlMessages.offlineStatusDescription),
        status: 'info',
      })
    }
  }

  render() {
    return null
  }
}

export default injectIntl(withToast(OfflineStatus))
